import React from "react";
import { Box } from "@mui/material";
import ImageCarousel from "../../Components/ImageCarousel/ImageCarousel";
import ActivitesSection from "../../Components/ActivitesSection/ActivitesSection";
import MeetTalk from "../../Components/Meet&Talk/Meet&Talk";
import { useStyles } from "./HomePageStyle";

const HomePage = () => {
  const classes = useStyles();
  return (
    <Box className={classes.HomePageMainContainer} id="accueil">
      <ImageCarousel />
      <ActivitesSection />
      <MeetTalk />
    </Box>
  );
};

export default HomePage;
